import { render, staticRenderFns } from "./add-user-form.vue?vue&type=template&id=0241c8c8&scoped=true&"
import script from "./add-user-form.vue?vue&type=script&lang=js&"
export * from "./add-user-form.vue?vue&type=script&lang=js&"
import style0 from "./add-user-form.vue?vue&type=style&index=0&id=0241c8c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0241c8c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
